import { inject, Injectable, signal } from '@angular/core';
import { Building } from '../../../models/building/building';
import { BuildingApiService } from '../../repository/flexseat/building-api.service';

@Injectable({
  providedIn: 'root'
})
export class BuildingService {

  private readonly buildingApi = inject(BuildingApiService);

  buildingsData = signal<Building[]>([]);  

  /**
   * Fetch buildings data from the API.
  */
  fetchBuildings(department :string, user: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.buildingApi.getSections(department, user).subscribe({
        next: (buildings) => {
          if (buildings) {

            this.buildingsData.set(buildings);

            resolve();
          }
          resolve();
        },
        error: (error) => {
          console.error('Error fetching reservations:', error);
          this.buildingsData.set([]);
          reject(error);
        }
      });
    });
  }


}
